
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { AuthComponent } from '@/components/auth/Auth';
import { useAuthSession } from '@/hooks/useAuthSession';
import { BannerUploadSection } from './BannerUploadSection';
import { OgImageSection } from './OgImageSection';
import { BackendDiagnostics } from './BackendDiagnostics';
import { SectionVisibilityToggle } from './SectionVisibilityToggle';

import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/components/ui/use-toast';
import { Link } from 'react-router-dom';

export const AdminSection = () => {
  const { session } = useAuthSession();
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const { toast } = useToast();

  const handleSignOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast({
        variant: "destructive",
        title: "Fehler beim Abmelden",
        description: error.message,
      });
    } else {
      toast({
        title: "Erfolgreich abgemeldet",
      });
    }
  };

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-lg mx-auto space-y-4">
          {session ? (
            <>
              {/* Backend Diagnostics - nur für eingeloggte Admins sichtbar */}
              <BackendDiagnostics />
              
              {/* Section Visibility Toggle */}
              <SectionVisibilityToggle />
              
              <BannerUploadSection />
              
              <OgImageSection />
              
              {/* New button for image upload page */}
              <Link to="/admin/og-image-upload">
                <Button 
                  className="w-full bg-green-600 hover:bg-green-700 text-white"
                >
                  Bilder für alle Sektionen hochladen
                </Button>
              </Link>
              
              <Button 
                onClick={handleSignOut}
                variant="destructive" 
                className="w-full"
              >
                Abmelden
              </Button>
            </>
          ) : (
            <Button 
              onClick={() => setAuthDialogOpen(true)}
              className="bg-blue-500 hover:bg-blue-600 text-white w-full"
            >
              Admin Login
            </Button>
          )}
          <Dialog open={authDialogOpen} onOpenChange={setAuthDialogOpen}>
            <AuthComponent open={authDialogOpen} onOpenChange={setAuthDialogOpen} />
          </Dialog>
        </div>
      </div>
    </section>
  );
};